import React, { useSyncExternalStore } from 'react'
import { MenuItem } from '@mui/material'

const ACTIVE_OPTION_SX = {
  backgroundColor: 'color-mix(in srgb, var(--color-primary-main) 8%, transparent)',
  boxShadow: 'inset 3px 0 0 var(--color-primary-main)',
}

const DropdownSearchOption = ({ highlight, activeOf, optionKey, sx, ...props }) => {
  const active = useSyncExternalStore(highlight.subscribe, () => activeOf(highlight.get()) === optionKey)
  return (
    <MenuItem
      {...props}
      onMouseMove={() => highlight.set(optionKey)}
      sx={active ? { ...ACTIVE_OPTION_SX, ...sx } : sx}
    />
  )
}

export default DropdownSearchOption
